var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8c1.912 0 3.467-1.57 3.467-3.5S8.412 1 6.5 1C4.588 1 3.033 2.57 3.033 4.5S4.588 8 6.5 8Zm1.3.875H5.2c-2.868 0-5.2 2.355-5.2 5.25V15h13v-.875c0-2.895-2.332-5.25-5.2-5.25Z",
  fill: "#00BAC6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.104 6.907a4.924 4.924 0 0 0 .666-3.015C12.61 2.328 11.729.946 10.286 0l-.98 1.46c.992.65 1.596 1.577 1.7 2.607a3.216 3.216 0 0 1-.95 2.617L9 7.73l1.434.416c3.75 1.087 3.794 4.817 3.794 4.855H16c0-1.568-.847-4.632-3.896-6.093Z",
  fill: "#00BAC6"
})));
export { SvgPeople as ReactComponent };
export default __webpack_public_path__ + "9924264028168ad5b304d32b5a52c270.svg";